import { CODE_ERRORS, HR_ERRORS } from 'common/domain/constants.errors';
import { STATES } from 'common/domain/states';
import { AUTHENTICATION_URL } from 'common/endpoints/endpoints.constants';

export default class ErrorInterceptorService {

  constructor($state, $log, $window, AuthenticationService, networkService) {
    'ngInject';
    this.state = $state;
    this.log = $log;
    this.window = $window;
    this.authenticationService = AuthenticationService;
    this.networkService = networkService;
  }

  manageError(responseError) {
    this.networkService.checkNetworkStatus();
    this._checkRedirectLogin(responseError);
  }

  _checkRedirectLogin(responseError) {
    const isStatusToRedirectLogin = responseError.status === CODE_ERRORS.FORBIDDEN;
    const isAPIUrl = responseError.config.url.includes(process.env.API_URL);
    const isNotUrlAuthentication = responseError.config.url !== AUTHENTICATION_URL;
    const hasToRedirectLogin = isStatusToRedirectLogin && isAPIUrl && isNotUrlAuthentication;
    const isUnAuthorized = responseError.status === CODE_ERRORS.UNAUTHORIZED;
    if (hasToRedirectLogin || isUnAuthorized) {
      this.authenticationService.redirectToLogin();
      return;
    }

    this._checkRedirectError(responseError);
  }

  _checkRedirectError(responseError) {
    const isAPIUrl = responseError.config.url.includes(process.env.API_URL);
    const isHRInternalServerError = responseError.status === CODE_ERRORS.INTERNAL_SERVER_ERROR && responseError.data.errors === HR_ERRORS.HR_SERVER_RESPONSE_ERRROR_OFFLINE;
    const isAngularCodeServerDownOrNoInternet = responseError.status === CODE_ERRORS.ANGULARJS_SERVER_DOWN_OR_NO_INTERNET && isAPIUrl;
    const isBackInternalServerError = responseError.status === CODE_ERRORS.INTERNAL_SERVER_ERROR;
    const hasToRedirectError = isHRInternalServerError || isAngularCodeServerDownOrNoInternet || isBackInternalServerError;

    this.log.info('_checkRedirectError hasToRedirectError', hasToRedirectError, 'isHRInternalServerError', isHRInternalServerError, 'isAngularCodeServerDownOrNoInternet', isAngularCodeServerDownOrNoInternet, 'isBackInternalServerError', isBackInternalServerError);

    if (hasToRedirectError) {
      this.log.info(`Error en el back con redirección a la página de error: ${JSON.stringify(responseError)}`);
      this._redirectToError();

    } else {
      this.log.info(`Error en el back sin redirección a la página de error: ${JSON.stringify(responseError)}`);

    }
  }

  _redirectToError() {
    this.state.go(STATES.ERROR);
    this.state.go = () => {};
    const isNativeWebview = /BBVAAutoservicios/.test(this.window.navigator.userAgent);
    if (!isNativeWebview) {
      this.window.location.reload();
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/common/interceptors/errorInterceptor/errorInterceptor.service.js